/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Login page component. The component displays the Login page details. 
 * 
 * App Name: SDI-Walmart
 * Author: Chandrasekar
 * Created Date: 07/30/2020 
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
/**
 * Ref: LN_PC_02
 * Importing the action and store file and set to an object.
 * 
 */
import swal from 'sweetalert';
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import * as LoginAction from '../actions/LoginAction';
import * as MenuAction from '../actions/MenuAction';
import LoginStore from '../stores/LoginStore'
import * as CookieService from '../CookieService';
import SDIConstants, { ConvertToEst } from '../SDIConstants';
import * as $ from 'jquery';
import i18n from '../i18n';
import Select, { components } from "react-select";
import { withTranslation, Trans } from 'react-i18next'
import { withAuth0 } from "@auth0/auth0-react";
import { v4 as uuid } from 'uuid' //WW-390_PC_01 (4/20/2022)-Aparna
import UnderMaintananceComponent from './UnderMaintananceComponent';
import BgOverlayComponent from './BgOverlayComponent';

const options = [
    {
        value: 'en', label: 'English', icon:
            "http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
    },
    {
        value: 'es', label: 'Español', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/MX.svg"
    },
    {
        value: 'fr', label: 'français', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg"
    }
]
const { Option } = components;
const IconOption = props => (
    <Option {...props}>
        <img
            src={props.data.icon}
            alt={props.data.label}
            style={{ "width": "12px" }}
        />
        {" "}
        {props.data.label}
    </Option>
);
class LoginComponent extends Component {
    _isMounted = false;
    /**
   * Ref: LN_PC_04
   * Define the constructor that takes props as parameter
   * 
   * @param props
   */
    constructor(props) {
        super(props);
        this.handleLoginChange = this.handleLoginChange.bind(this);
        //this.assignLoginData = this.assignLoginData.bind(this);
        //this.checkThrirdPartyResp = this.checkThrirdPartyResp.bind(this);
        this.loginSuccess = this.loginSuccess.bind(this);
        this.loginFailure = this.loginFailure.bind(this);
        this.loginClick = this.loginClick.bind(this);
        this.loginKeyPress = this.loginKeyPress.bind(this);
        this.SSOKeyPress = this.SSOKeyPress.bind(this)
        this.SSOLoginClick = this.SSOLoginClick.bind(this);
        this.PassKeyPress = this.PassKeyPress.bind(this);
        this.getLoginOutageData = this.getLoginOutageData.bind(this);
        this.getLoginOutageDataResponse = this.getLoginOutageDataResponse.bind(this);

        /**
        * Ref: LN_PC_05D
        * Set the initial values of the state variables
        */
        this.state = {
            userName: "", password: "", language: CookieService.getLocalStorageValues("newlanguage"), error_description: "", showPassword: false,
            loginData: { isBrowserCompatable: true }, isLogout: CookieService.getLocalStorageValues("isLogout"),
            isSSOClick: CookieService.getLocalStorageValues("isSSOClick"), isThirdParty: false, EmailAddres: "", ssoErrorDesc: "", SSOLogin: true,//WW-721_PC_01 (12/19/2023)-Aparna
            displayText: "",
            isredirect: "",
            resultMessage: ""
        }
        if (CookieService.getLocalStorageValues("isSSOClick") == true) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
    }

    componentDidUpdate(prevProps) {
        const { loginWithRedirect, user, isAuthenticated, isLoading } = this.props.auth0;
        if (isAuthenticated != undefined) {
            // if (isAuthenticated !== prevProps.auth.isAuthenticated) {
            if (isAuthenticated == true && this.state.isLogout != true) {
                let IDToken = CookieService.getLocalStorageValues("IDTokenAuth0");
                if (IDToken != undefined && IDToken != null) {
                    //console.log("componentDidUpdate")

                    this.Auth0Login(IDToken);
                } else {
                    let token = this.getIDToken(this.props.auth0);
                }

            }
            // }
        }
    }

    /**
   * Ref: LN_PC_10
   * Event listener method that gets called to handle the
   * Login failure status codes from store
   * Based on the Status codes the validation message will be displayed
   */

    loginFailure = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let loginClickData = JSON.parse(LoginStore.loginError);
        let loginErrorMsg = "";
        let result;
        //WW-1287 login click outage data response - Nandhini L
        if (loginClickData.error == "8") {
            let result = JSON.parse(loginClickData.error_description);
            //result = loginClickData.error_description;
            if (result) {
                const localStorageLanguageCode = CookieService.getLocalStorageValues("newlanguage") ? CookieService.getLocalStorageValues("newlanguage") : options[0];
                //const { result } = Filecheck;
                let isredirect = "True";
                const langResult = result[0].messages;
                const displayDateTimeStart = ConvertToEst(result[0].displayDateTimeStart);
                const outageDateTimeStart = ConvertToEst(result[0].outageDateTimeStart);
                const outageDateTimeEnd = ConvertToEst(result[0].outageDateTimeEnd);

                const filteredLangResult = langResult.find(msg => msg.languageCode === localStorageLanguageCode.value);
                let externalMessage = filteredLangResult && filteredLangResult.externalMessage;
                externalMessage = externalMessage
                    .replace('outageDateTimeStart', outageDateTimeStart)
                    .replace('outageDateTimeEnd', outageDateTimeEnd);

                this.setState({
                    displayText: externalMessage,
                    isredirect: isredirect,
                    resultMessage: result
                })

                this.props.DisplayOutageData(isredirect, externalMessage, result);

                this.props.history.push({
                    pathname: `/underMaintanance`,
                });

            }
        }
        else {
            //console.log("login fail", loginClickData);
            //[12/20/2022]WW-456 Set Stating the error messages for SSO login and normal login flows
            if (this.state.isSSOClick == true) {
                if (loginClickData.error == "1") {
                    loginErrorMsg = loginClickData.error_description;
                }
                else {
                    loginErrorMsg = "Invalid email address";
                }
                CookieService.updateLocalStorageValues("SSOFirstHit", false)
                this.setState({ ssoErrorDesc: loginErrorMsg });
            }
            else {
                if (loginClickData.error == "1") {
                    loginErrorMsg = loginClickData.error_description;

                } else if (loginClickData.error == "2") {
                    let failureAttemptCount = CookieService.getCookieValue(this.state.userName.toLowerCase());
                    if (failureAttemptCount != "") {
                        CookieService.setCookieValues(this.state.userName.toLowerCase(), 0, 1);
                    }
                    loginErrorMsg = loginClickData.error_description;
                } else if (loginClickData.error == "3" || loginClickData.error == "5") {
                    let failureAttemptCount = CookieService.getCookieValue(this.state.userName.toLowerCase());
                    if (failureAttemptCount == "") {
                        failureAttemptCount = 1;
                    } else {
                        failureAttemptCount = parseInt(failureAttemptCount) + 1;
                    }
                    CookieService.setCookieValues(this.state.userName.toLowerCase(), failureAttemptCount, 1);
                    loginErrorMsg = loginClickData.error_description;
                } else if (loginClickData.error == "4") {
                    this.props.history.push({
                        pathname: `/ChangePassword`,
                        search: `?USERID=${this.state.userName}`
                    });
                } else if (loginClickData.error == "invalid_grant" || loginClickData.error == "7") { //WW-1248 -Vishwa S
                    loginErrorMsg = loginClickData.error_description;
                }
                CookieService.updateLocalStorageValues("LoginFirstHit", false)
                this.setState({ error_description: loginErrorMsg });
            }
        }

    }
    /**
    * Ref: LN_PC_10
    * Event listener method that gets called to get the
    * Login success response from store.
    * This method will store the user data to localStorage
    */
    loginSuccess = () => {
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
        const { t }= this.props
        this.setState({ error_description: "" });
        let loginSuccessData = JSON.parse(LoginStore.loginSuccess);

        if (loginSuccessData.length > 0) {
            loginSuccessData = loginSuccessData[0];
            loginSuccessData.isSuccess = (loginSuccessData.isSuccess.toLowerCase() == "true")
            if (loginSuccessData.isSuccess) {
                //console.log("loginSuccessData", loginSuccessData);
                //console.log("BU", CookieService.getLocalStorageValues("Session_BUSUNIT").trim().toUpperCase());
                if (CookieService.getLocalStorageValues("Session_BUSUNIT").trim().toUpperCase() != 'I0W01') {
                    let lastversion = CookieService.getLocalStorageValues("lastVersion");
                    localStorage.clear();
                    if (lastversion != undefined) {
                        CookieService.updateLocalStorageValues("lastVersion", lastversion);
                    }
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t('Warning!\nYou do not have permission to access the application')
                    });

                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    return;
                }
                //console.log("bgmlang123", CookieService.getLocalStorageValues("newlanguage"))
                //WW-390_PC_01 (4/20/2020) -Aparna
                let randomId = Math.floor(Math.random() * 10000000000)
                CookieService.updateLocalStorageValues("Session_ID", randomId)
                //console.log("uuid", randomId)
                //console.log("Session_ID", CookieService.getLocalStorageValues("Session_ID"))
                CookieService.updateLocalStorageValues("Shipment_Method", false)
                let queryParams = new URLSearchParams(window.location.search);
                let orderStatusFlg = queryParams.get('orderstatus');
                if (orderStatusFlg != "" && orderStatusFlg == "Y") {
                    this.props.history.push({
                        pathname: `\orderstatus2`,
                        state: { origin: 'Login', ordno: queryParams.get('ordno') }
                    });
                    CookieService.updateLocalStorageValues("isLogout", true);
                }
                else {
                    this.props.history.push({
                        pathname: '/HomePage',
                    });
                    CookieService.updateLocalStorageValues("isLogout", false)
                }
                //MenuAction.refreshMenuItems(true, this.props);                
                //CookieService.updateLocalStorageValues("isLogout", false);

            } else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                if (this.state.isSSOClick == true) {
                    CookieService.updateLocalStorageValues("SSOFirstHit", false);
                    this.setState({ ssoErrorDesc: "Client is inactive" });
                }
                else {
                    CookieService.updateLocalStorageValues("LoginFirstHit", false);
                    this.setState({ error_description: "Client is inactive" });
                }


            }
        } else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        this.props.DisplayOutageData(false, "", "");

    }
    /**
     * Ref: LN_PC_11
     * Event listener method that gets called to load the
     * Login page load data from store.
     */
    getDBUrl = async () => {

        await $.ajax({
            type: "GET",
            url: SDIConstants.DB
        }).then(response => {
            let DB_Response = response;
            let DB = DB_Response.split("|")
            sessionStorage.setItem("oraAccessCNstring", DB[1]);
            sessionStorage.setItem("OLEDBconString", DB[0]);
            CookieService.updateLocalStorageValues("Session_WEBSITEID", DB[2]);
            CookieService.updateLocalStorageValues("Session_IOLServer", "");
            CookieService.updateLocalStorageValues("Session_cplusServer", "");

            if (!(DB[0].toLowerCase().includes("fsprd") && DB[1].toLowerCase().includes("fsprd"))) {
                let a = CookieService.getLocalStorageValues("BackFromForgotOrChgPass");
                if (!this.state.isSSOClick && (CookieService.getLocalStorageValues("BackFromForgotOrChgPass") == false || CookieService.getLocalStorageValues("BackFromForgotOrChgPass") == undefined) && !(this.props && this.props.history && this.props.history.location && this.props.history.location.origin == "APPROVALS")) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "**Warning - this is a test web site only...\nNo activity will be recorded as production."
                    })
                }
            }
            CookieService.updateLocalStorageValues("BackFromForgotOrChgPass", false);
            let propslang = this.props.propslang
            CookieService.updateLocalStorageValues("newlanguage", propslang);
            //console.log("propslang", CookieService.getLocalStorageValues("newlanguage"))
        })
    }


    /**
     * componentDidMount method will be invoked once the page is loaded and HTMls are rendered
     * This method will set the title of the page
     */
    componentWillMount() {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    componentDidMount() {

        let isFromForgotOrChngPass = CookieService.getLocalStorageValues("BackFromForgotOrChgPass");
        if (isFromForgotOrChngPass == true) {
            this.BackToSSOLogin(false, false);
        }
        //WW-1248 Active/inactive approval flow -Vishwa S
        if (this.props && this.props.history && this.props.history.location && this.props.history.location.origin == "APPROVALS") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Your account is inactive" + "\n" + "Please contact the help desk at" + " " + this.props.history.location.phoneNo + " " + "to reinstate your account"
            }).then(() => {
                if (window.location.pathname.toLowerCase() === '/homepage') {
                    this.logout();
                }
            });
        }
        //PC_WW-617_26-Getting contact deatils
        this.getContactDetails()
        let lastversion = this.props.lastversion;
        if (lastversion != undefined) {
            CookieService.updateLocalStorageValues("lastVersion", lastversion);
        }
        const { detect } = require('detect-browser');
        const browser = detect();
        if (browser) {
            let browserName = browser.name
            let browserVersion = browser.version
            //console.log("browsername", browser.name);
            //console.log("browserversion", browser.version);
            //console.log("browse", browserVersion.toString().substring(0, 2))
            //console.log("browseros", browser.os);
            if ((browserName.toLowerCase() == "internet explorer") && (browserVersion.toString().substring(0, 2) == "7.0" || browserVersion.toString().substring(0, 2) == "8.0")) {
                alert("Brower is not supported")
            }
        }
        this._isMounted = true;
        document.title = this.props.title;
        let IDToken = CookieService.getLocalStorageValues("IDTokenAuth0");
        const { loginWithRedirect, user, isAuthenticated, isLoading } = this.props.auth0;
        //  if (isAuthenticated == true) {
        //if (IDToken != undefined && IDToken != null) {
        //    this.Auth0Login(IDToken);
        //}

        // }
        //  else {
        let queryParams = new URLSearchParams(window.location.search);
        let orderStatusFlg = queryParams.get('orderstatus');
        let isTokenPresent = CookieService.getCookieValue(SDIConstants.access_token);
        this.getLoginOutageData()
        if (isTokenPresent != "") {
            if (orderStatusFlg != "" && orderStatusFlg == "Y") {
                this.props.history.push({
                    pathname: `\orderstatus2`,
                    state: { origin: 'Login', ordno: queryParams.get('ordno') }
                });
            }
            else {
                this.props.history.push({
                    pathname: '/HomePage',
                });
            }
        } else {
            sessionStorage.clear();
            let lastversion = CookieService.getLocalStorageValues("lastVersion");
            localStorage.clear();
            if (lastversion != undefined) {
                CookieService.updateLocalStorageValues("lastVersion", lastversion);
            }
            //  }

            /**
            * Ref: LN_PC_08
            * Invoke the action to get the page load data from API.
            */
            CookieService.updateLocalStorageValues("BackFromForgotOrChgPass", isFromForgotOrChngPass);
            this.getDBUrl();
            if (!this.state.isSSOClick) {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
            /**
           * Ref: LN_PC_07
           * Define the listener methods
           */
            LoginStore.on('load', this.getLoginOutageDataResponse);
            LoginStore.on('success', this.loginSuccess);
            LoginStore.on('error', this.loginFailure);
            LoginStore.on('ThirdPartyLoginResp', this.ThirdPartyResponse);
            LoginStore.on('contactDet', this.phoneNumberResponse);
        }
    }

    //WW-1287 To get pageload outage data - Nandhini L
    getLoginOutageData = () => {
        let BO = {
            SystemCode: "WALW"
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        LoginAction.pageLoad(BO);
    }

    //WW-1287 pageload outage data response - Nandhini L
    getLoginOutageDataResponse = () => {
        const res = JSON.parse(LoginStore.loginData);
        let Filecheck = res.Filecheck;
        if (Filecheck && Filecheck[0].result) {
            const localStorageLanguageCode = CookieService.getLocalStorageValues("newlanguage") ? CookieService.getLocalStorageValues("newlanguage") : options[0];
            let result = JSON.parse(Filecheck[0].result);

            let isredirect = Filecheck[0].isredirect;

            const langResult = result[0].messages;
            const displayDateTimeStart = ConvertToEst(result[0].displayDateTimeStart);
            const outageDateTimeStart = ConvertToEst(result[0].outageDateTimeStart);
            const outageDateTimeEnd = ConvertToEst(result[0].outageDateTimeEnd);

            const filteredLangResult = langResult.find(msg => msg.languageCode === localStorageLanguageCode.value);

            let externalMessage = filteredLangResult && filteredLangResult.externalMessage;
            externalMessage = externalMessage
                .replace('outageDateTimeStart', outageDateTimeStart)
                .replace('outageDateTimeEnd', outageDateTimeEnd);

            this.setState({
                displayText: externalMessage,
                isredirect: isredirect,
                resultMessage: result
            })

            $(`#${SDIConstants.SDILoader}`).addClass('hide');

            this.props.DisplayOutageData(isredirect, externalMessage, result);
        }
    };

    /**
    * handleLoginChange method will be invoked on the change event of username and password text box
    * to set the values to state
    */
    getContactDetails = () => {
        LoginAction.getContactDetails("I0W01");
    }
    handleLoginChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    handleZeusIDChange = (event) => {
        this.setState({ userName: event.target.value });
    }
    handleEmailIDChange = (event) => {
        this.setState({ EmailAddres: event.target.value });
    }

    /**
    * componentWillUnmount method will be invoked once the component is unloaded from the page
    */
    componentWillUnmount() {
        this._isMounted = false;
        LoginStore.removeListener('load', this.getLoginOutageDataResponse);
        LoginStore.removeListener('success', this.loginSuccess);
        LoginStore.removeListener('error', this.loginFailure);
        LoginStore.removeListener('ThirdPartyLoginResp', this.ThirdPartyResponse);
        LoginStore.removeListener('contactDet', this.phoneNumberResponse);
    }
    /**
    * Ref: LN_PC_09
    * loginClick will be invoked when login button is clicked
    * Validate the Username and password and invoke the action to validate the login credentials with Database.
    */
    //PC_WW-617_32-Getting contact detail response
    phoneNumberResponse = () => {
        let phoneNumberResponse = JSON.parse(LoginStore.contactDetails)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let response = phoneNumberResponse.Table[0];
        CookieService.updateLocalStorageValues("WAL_PHONE_NUM", response.PHONE_NUM);
        CookieService.updateLocalStorageValues("WAL_EMAIL_ID", response.EMAIL_ID);
        CookieService.updateLocalStorageValues("WAL_CONTACT_FLAG", response.PHONE_EMAIL_VISIBLE);
        this.props.ContactDetailsUpdate(response.PHONE_EMAIL_VISIBLE);
        let IDToken = CookieService.getLocalStorageValues("IDTokenAuth0");
        const { loginWithRedirect, user, isAuthenticated, isLoading } = this.props.auth0;

        if (isAuthenticated == true && this.state.isLogout != true) {
            if (IDToken != undefined && IDToken != null) {

                this.Auth0Login(IDToken);
            } else {
                let token = this.getIDToken(this.props.auth0);
            }

        }
        this.props.DisplayOutageData(false, "", "");
        //else if (isLoading == true && this.state.isLogout != true && isAuthenticated == false) {

        //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //    loginWithRedirect();
        //}
    }
    loginClick = (event) => {
        const { t } = this.props
        event.preventDefault();
        let lastversion = this.props.lastversion;
        if (lastversion != undefined) {
            CookieService.updateLocalStorageValues("lastVersion", lastversion);
        }
        CookieService.updateLocalStorageValues("isSSOClick", false);
        //5622 - updated a validation if user not filled any 1 field particular field error msg will be display [4/16/2025] Nachiappan C
        if (!this.state.userName && !this.state.password) {
            CookieService.updateLocalStorageValues("LoginFirstHit", false);
            this.setState({ error_description: "Please enter your zeus ID and password" });
            return; // Exit the function early
        }

        // Check if username is empty
        if (!this.state.userName) {
            CookieService.updateLocalStorageValues("LoginFirstHit", false);
            this.setState({ error_description: t("Please enter zeus ID") });
            return; // Exit the function early
        }

        // Check if password is empty
        if (!this.state.password) {
            CookieService.updateLocalStorageValues("LoginFirstHit", false);
            this.setState({ error_description: t("Please enter a password") });
            return; // Exit the function early
        }
            this.setState({ error_description: "" });
            let failureAttemptCount = CookieService.getCookieValue(this.state.userName.toLowerCase());
            if (failureAttemptCount == "") {
                failureAttemptCount = 1
            } else {
                failureAttemptCount = parseInt(failureAttemptCount) + 1;
            }
            //***************NEW(1/27/2021)*********
            let UserId = this.state.userName
            if (this.state.userName != null && this.state.userName != undefined && this.state.userName != "") {
                if (this.state.userName.length > 0) {
                    UserId = UserId.replaceAll("&", "SDISPECAILCASE#!")
                    UserId = UserId.replaceAll("+", "SDISPECAILCASENEW#!")
                }
            }
            //******END***************
            let loginClickBO = {
                userName: UserId,
                password: this.state.password,
                failureAttemptCount: failureAttemptCount,
                failureAttemptUname: this.state.userName,
                PARAM_DESTINATION_URL: "",
                authToken: "",
                isWeb: true,
                OLEDBconString: sessionStorage.getItem("OLEDBconString"),
                oraAccessCNstring: sessionStorage.getItem("oraAccessCNstring"),
                SystemCode: "WALW"

            }
            //console.log("bgmlangbgover", CookieService.getLocalStorageValues("newlanguage"))

            LoginAction.loginClick(loginClickBO, this.state.loginData);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        
    };
    loginKeyPress(e) {
        if (e.keyCode == 13) {
            this.loginClick(e);
        }
    };
    // [02/07/24, bug 3962 restrict space bar in password] Nandhini L
    PassKeyPress(e) {
        if (e.keyCode == 13) {
            this.loginClick(e);
        }
        else if (e.keyCode == 32) {
            e.preventDefault();
        }
    };

    // [07/12/2022, bug 2277 eye icon for password ]Pavithra R
    handleClickShowPassword = (values) => {
        this.setState({ showPassword: !this.state.showPassword })
    };

    handleMouseDownPassword = (event) => {
        event.preventDefault();

    };
    handlePaste = (e) => {
        e.preventDefault();
    };
    handleKeyDown = (e) => {

        let val = e.key;
        if (e.key === " " || e.key === "'" || e.key === '"') {
            e.preventDefault();
        }

    };

    //[12/20/2022]WW-456 SSOKeyPress() will call SSOloginClick method if the enter key is pressed after entering email ID 
    SSOKeyPress(e) {

        if (e.keyCode == 13) {
            this.thirdPartyLogin();
            //this.SSOLoginClick();
        }
    };

    //[12/20/2022]WW-456 SSOLoginClick() will validate the email ID entered and calls loginwithrdirect if email is valid
    SSOLoginClick = () => {

        CookieService.updateLocalStorageValues("isSSOClick", true)
        const { loginWithRedirect, user, isAuthenticated, isLoading } = this.props.auth0;
        if (isAuthenticated == false) {
            loginWithRedirect();
        }
        else {
            let IDToken = CookieService.getLocalStorageValues("IDTokenAuth0");
            if (IDToken != undefined && IDToken != null) {
                this.Auth0Login(IDToken);
            }
            else {
                let token = this.getIDToken(this.props.auth0);
            }
        }
    };

    thirdPartyLogin = () => {

        let EmailId = this.state.EmailAddres;
        CookieService.updateLocalStorageValues("isSSOClick", true);
        if (this.state.EmailAddres == "") {
            CookieService.updateLocalStorageValues("SSOFirstHit", false);
            this.setState({ ssoErrorDesc: "Please enter email address" });
            return;
        }
        else {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(this.state.EmailAddres)) {
                CookieService.updateLocalStorageValues("SSOFirstHit", false);
                this.setState({ ssoErrorDesc: "Please enter valid email address" });
                return;
            }
            else {
                LoginAction.thirdPartyLogin(EmailId);
            }
        }
    }

    ThirdPartyResponse = () => {
        const { t } = this.props
        let thirdPartyResp = LoginStore.ThirdPartyLoginResp;
        if (thirdPartyResp == "ThirdPartyUser") {
            this.setState({ isThirdParty: true, userName: this.state.EmailAddres });
        }
        else if (thirdPartyResp == "Invalid Email") {
            CookieService.updateLocalStorageValues("SSOFirstHit", false);
            this.setState({ ssoErrorDesc: "Invalid Email Address" });
        }
        else if (thirdPartyResp == "NonWalMartUser") {
            let lastversion = CookieService.getLocalStorageValues("lastVersion");
            localStorage.clear();
            if (lastversion != undefined) {
                CookieService.updateLocalStorageValues("lastVersion", lastversion);
            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Warning!\nYou do not have permission to access the application')
            });
            return;
        }
        else if (thirdPartyResp == "Internal Error") {
            CookieService.updateLocalStorageValues("SSOFirstHit", false);
            this.setState({ ssoErrorDesc: "Internal Error" });
        }
        else if (thirdPartyResp == "WalMartUser") {
            this.SSOLoginClick();
        }
        this.props.DisplayOutageData(false, "", "");

    }
    //[12/20/2022]WW-456 Auth0Login() will be hit when the Auth0 authentication is success and calls the loginClick action method
    Auth0Login = (IDToken) => {

        //console.log("Auth0IDtoken", IDToken)
        let failureAttemptCount = CookieService.getCookieValue(this.state.EmailAddres.toLowerCase());
        if (failureAttemptCount == "") {
            failureAttemptCount = 1
        } else {
            failureAttemptCount = parseInt(failureAttemptCount) + 1;
        }
        let loginClickBO = {
            userName: "",
            password: "",
            failureAttemptCount: failureAttemptCount,
            failureAttemptUname: "",
            PARAM_DESTINATION_URL: "",
            authToken: IDToken,
            isWeb: true,
            OLEDBconString: sessionStorage.getItem("OLEDBconString"),
            oraAccessCNstring: sessionStorage.getItem("oraAccessCNstring")
        }
        //console.log("renderSSO", IDToken)
        LoginAction.loginClick(loginClickBO, this.state.loginData);
    }

    async getIDToken(AuthProps) {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        await AuthProps.getIdTokenClaims().then(token => {
            if (token.__raw != undefined) {
                CookieService.updateLocalStorageValues("IDTokenAuth0", token.__raw);
            }
        });
        console.log("AuthProps", AuthProps)
        let IDToken = CookieService.getLocalStorageValues("IDTokenAuth0");
        //console.log("IDToken", IDToken)
        let isIDTokenAvailable = false

        if (IDToken != null && IDToken != undefined && IDToken != "") {
            isIDTokenAvailable = true
            //console.log("isIDTokenAvailable", isIDTokenAvailable)
        }
        if (AuthProps.isAuthenticated == true && isIDTokenAvailable == true && this.state.isLogout != true) {
            this.Auth0Login(IDToken);
        }
        return IDToken;
    }
    BackToSSOLogin = (SSOLogin, SSOClick) => {
        let displayText = CookieService.getLocalStorageValues("displayText");
        let isredirect = CookieService.getLocalStorageValues("isredirect");
        let resultMessage = CookieService.getLocalStorageValues("resultMessage");

        this.props.DisplayOutageData(isredirect, displayText, resultMessage);

        if (SSOLogin) {
            this.setState({ userName: "", showPassword: "", password: "", error_description: "", SSOLogin: true, isLogout: false });
            CookieService.updateLocalStorageValues("isLogout", false);
            CookieService.updateLocalStorageValues("SSO", SSOClick);
            //console.log("isSSOClick-BackToSSOLogin", CookieService.getLocalStorageValues("SSO"))
            if (SSOClick) {
                this.SSOLoginClick();
            }
        }
        else {
            this.setState({ SSOLogin: false })
        }
    }
    //WW-1248 method to logout the user -Vishwa S
    logout = () => {
        let newlang = CookieService.getLocalStorageValues("newlanguage");
        let lastversion = CookieService.getLocalStorageValues("lastVersion");
        CookieService.setCookieValues(SDIConstants.access_token, "", -1);
        localStorage.clear();
        CookieService.updateLocalStorageValues("lastVersion", lastversion);
        let lv = CookieService.getLocalStorageValues("lastVersion");
        CookieService.updateLocalStorageValues("newlanguage", newlang);
        CookieService.updateLocalStorageValues("isSSOClick", false);
        CookieService.updateLocalStorageValues("isLogout", true);
        const { logout } = this.props.auth0;
        logout({ returnTo: window.location.origin });
    }

    render() {
        //Login Page translation - Dhamotharan P
        const { t } = this.props;
        let DB = sessionStorage.getItem("DB");
        let lastversion = this.props.lastversion;
        if (lastversion != undefined) {
            CookieService.updateLocalStorageValues("lastVersion", lastversion);
        }
        if (this.state.isSSOClick) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        }
        //[12/20/2022]WW-456 Declaring Auth0 functionalities to access Auth0 when user  does SSO
        const { isAuthenticated, getIdTokenClaims } = this.props.auth0;
        let ssoErrorMsg = "";
        let nrmErrorMsg = "";
        if (CookieService.getLocalStorageValues("SSOFirstHit") == true) {
            ssoErrorMsg = "";
        }
        else {
            ssoErrorMsg = this.state.ssoErrorDesc;
        }
        if (CookieService.getLocalStorageValues("LoginFirstHit") == true) {
            nrmErrorMsg = "";
        }
        else {
            nrmErrorMsg = this.state.error_description;
        }
        //let normalLogin = CookieService.getLocalStorageValues("ShowNormalLogin");
        //if (this.props.showNormalLogin == true) {
        //    CookieService.updateLocalStorageValues("ShowNormalLogin", false);
        //}
        //let ShowNormalLogin = false
        //if (normalLogin == true || this.state.isThirdParty == true || this.props.logoClickCount == 3 || this.props.showNormalLogin==true) {
        //WW-721_PC_02 (12/19/2023)-Aparna
        if (this.state.SSOLogin) {
            // ShowNormalLogin = true
            CookieService.updateLocalStorageValues("isSSOClick", false)
        }

        let isLoginSuccess = CookieService.getLocalStorageValues("isLoginSuccess");

        //if (isAuthenticated == true && this.state.isLogout != true && this.state.SSOLogin == true && this.state.isSSOClick == true) {
        //    //[12/20/2022]WW-456 getIdTokenClaim() will get ID token from Auth0 SDK if the user logged in with SSO is valid
        //    let token = this.getIDToken(this.props.auth0);
        //}

        return (this.state.SSOLogin == true ? <React.Fragment>
            <p className="text-white mt-4 mb-3 font-24 font-thin text-center"><Trans>Log in to your account</Trans></p>
            {/* <div className="user-id position-relative">
                <input type="text" id="EmailId" name="EmailAddres" value={this.state.EmailAddres} maxLength="30" className="form-control font-12 login-control custom-margin pb-1 txtBox-Border" placeholder={t("Email Address")} onKeyDown={this.SSOKeyPress} onChange={this.handleEmailIDChange} />
            </div>

            <span className="float-left err-msg text-danger mb-5">{ssoErrorMsg}</span>*/}
            {/*<div className="col-12 p-0 float-left">
                <a href="#" id="loginSSO" className="btn btn-primary custom-btn-primary col-12 text-center login-btn" onClick={() => this.BackToSSOLogin(true)}><Trans>Continue with SDI</Trans></a>
            </div>
            <div className="col-12 p-0 float-left">
                <a href="#" id="loginSSO" className="btn btn-primary custom-btn-primary col-12 text-center login-btn" onClick={() => this.BackToSSOLogin(false)}><Trans>Continue with SDI</Trans></a>
            </div>*/}
            <div className="col-12 p-0 float-left mt-2">
                <button
                    type="button"
                    className="btn btn-primary col-12 text-center login-btn text-white font-regular font-14 py-2" onClick={() => this.BackToSSOLogin(true, true)}>
                    <Trans>Sign in with </Trans>
                    <span>
                        Walmart{" "}
                        <img
                            className="walmart-icon-style mb-1"
                            src="images/walmart-logo.svg"
                            alt="walmart"
                        /> {" "}
                    </span>
                    SSO
    </button>
            </div>
            <div className="col-12 p-0 float-left position-relative my-4">
                <span className="position-absolute bg-line-style" />
                <span className="position-relative w-100 text-center or-style px-2" style={{ left: "44%" }}>(<Trans>or</Trans>)</span>
            </div>
            <div className="col-12 p-0 float-left">
                <button type="button" className="btn btn-transparent col-12 text-white font-regular font-14 py-2" onClick={() => this.BackToSSOLogin(false, false)}>
                    <Trans>Sign in with </Trans>
                    <img
                        className="sdi-logo-style mb-1"
                        src="images/sdi-logo-button.png"
                        alt="sdi-logo"
                    />
                </button>
            </div>
        </React.Fragment> : <React.Fragment>
                <p className="text-white mt-4 mb-3 font-24 font-thin text-center"><Trans>Log in to your account</Trans></p>
                {/*11/11/22, PS_WW-538_01 - Adding the maxlength as 30 characters for the user ID, Dhevanesam R]*/}
                <div className="user-id position-relative">
                    <input type="text" id="ZeusId" name="userName" value={this.state.userName} maxLength="30" className="form-control font-12 login-control custom-margin pb-1 txtBox-Border" placeholder={t("Zeus ID")} onKeyDown={this.loginKeyPress} onChange={this.handleZeusIDChange} />
                </div>

                <div className="Password position-relative p-0">

                    {/*15/08/23, 3968 - Adding the maxlength as 128 characters for the password, Vishwa S]*/}
                    <Input type={this.state.showPassword ? "text" : "password"} style={{ color: "white" }} name="password" id="password" onPaste={this.handlePaste} className="form-control font-12 login-control mb-5 pb-1 pr-0" placeholder={t("Password")} inputProps={{ maxLength: 128 }} value={this.state.password} onKeyDown={this.PassKeyPress} onChange={this.handleLoginChange}
                        endAdornment={
                            <InputAdornment position="end" >
                                <IconButton
                                    style={{ color: "#707070" }}
                                    onClick={(e) => this.handleClickShowPassword(e)}

                                >
                                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        } />
                </div>
                <span className="float-left err-msg text-danger mb-5"><Trans>{nrmErrorMsg}</Trans></span>
                <div className="col-12 p-0 float-left">
                    <a href="#" className="btn btn-primary custom-btn-primary col-12 text-center login-btn" id="loginSubmit" onClick={this.loginClick}><Trans>Login</Trans></a>
                </div>
                <div className="w-100 d-flex justify-content-between">
                    <Link className="mt-4 forgot-pw p-0" id="back" style={{ textAlign: "left" }} onClick={() => this.BackToSSOLogin(true, false)}><Trans>Back</Trans></Link>
                    <Link to={`/forgotpassword?userID=${this.state.userName}`} className="mt-4 forgot-pw text-nowrap p-0" ><Trans>Forgot Password</Trans> <span>?</span></Link>
                </div>
            </React.Fragment>)
        if (this.state.isSSOClick) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        }

    }
}
export default withAuth0(LoginComponent);